import { login, LoginParams, logout } from '@3fourteen/core';
import { crsBugsnag, mainBugsnag } from 'helpers/bugsnag';

const AUTH_COOKIE = 'auth_session';

export function setAuthCookie() {
  document.cookie = `${AUTH_COOKIE}=1; path=/; SameSite=Lax; Secure`;
}

export function clearAuthCookie() {
  document.cookie = `${AUTH_COOKIE}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}

export const onLogin = async (email: LoginParams['email'], password: LoginParams['password']) => {
  try {
    const data = await login({
      email,
      password,
    });
    const { authToken, userId, databaseId } = data;

    if (!!authToken && !!userId && !!databaseId) {
      localStorage.setItem('userId', userId);
      localStorage.setItem('databaseId', `${databaseId}`);
      setAuthCookie();
    }

    mainBugsnag.setUser(userId, email);
    crsBugsnag.setUser(userId, email);

    return {
      authToken,
      userId,
    };
  } catch (e: any) {
    mainBugsnag.notify(e, (event) => {
      event.context = 'onLogin() from auth service';
    });
    throw e;
  }
};

export const onLogout = async () => {
  await logout();

  localStorage.removeItem('userId');
  localStorage.removeItem('databaseId');
  clearAuthCookie();

  window.location.href = '/login';
};
